import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { TrlDateFormatted } from '»utils/date';
import { TrlFormattedMessagePlain } from '»utils/i18n';
import { TrlNumberFormatted } from '»utils/number';

import {
  BoxContainerStyled,
  BoxValuesStyled,
  ContainerLeftStyled,
  LabelHeaderStyled,
  LabelStyled,
  LabelValueStyled,
} from '../TrlPrimaryMarketIssue/TrlPrimaryMarketIssue.styles';

export const TrlPrimaryFund = ({ dataItem }) => {
  const {
    securityDescription,
    fundManager,
    symbol,
    currency,
    subscriptionPrice,
    subscriptionDate,
    endDate,
    revokeDate,
    initialAmount,
  } = dataItem;

  return (
    <BoxContainerStyled id="divFundIssue">
      <LabelHeaderStyled>
        <FormattedMessage id="TRLT_UI-FUND" />
      </LabelHeaderStyled>
      <BoxValuesStyled>
        <ContainerLeftStyled>
          <LabelStyled>
            {TrlFormattedMessagePlain({
              id: 'TRLT_UI-SECURITY',
            })}
          </LabelStyled>
          <LabelValueStyled>{securityDescription}</LabelValueStyled>
          <LabelStyled>
            {TrlFormattedMessagePlain({
              id: 'TRLT_UI-MANAGEMENT_COMPANY',
            })}
          </LabelStyled>
          <LabelValueStyled>{fundManager}</LabelValueStyled>
          <LabelStyled>
            {TrlFormattedMessagePlain({
              id: 'TRLT_UI-TICKER',
            })}
          </LabelStyled>
          <LabelValueStyled>{symbol}</LabelValueStyled>
          <LabelStyled>
            {TrlFormattedMessagePlain({
              id: 'TRLT_UI-CURRENCY',
            })}
          </LabelStyled>
          <LabelValueStyled>{currency}</LabelValueStyled>
          <LabelStyled>
            {TrlFormattedMessagePlain({
              id: 'TRLT_UI-PRICE',
            })}
          </LabelStyled>
          <LabelValueStyled>
            <TrlNumberFormatted value={subscriptionPrice} decimalDigits={2} />
          </LabelValueStyled>
        </ContainerLeftStyled>
        <ContainerLeftStyled>
          <LabelStyled>
            {TrlFormattedMessagePlain({
              id: 'TRLT_UI-SUBSCRIPTION_DATE',
            })}
          </LabelStyled>
          <LabelValueStyled>
            <TrlDateFormatted date={subscriptionDate} />
          </LabelValueStyled>
          <LabelStyled>
            {TrlFormattedMessagePlain({
              id: 'TRLT_UI-END_INTENTION',
            })}
          </LabelStyled>
          <LabelValueStyled>
            <TrlDateFormatted date={endDate} />
          </LabelValueStyled>
          <LabelStyled>
            <FormattedMessage id="TRLT_UI-MODIFICATION_LIMIT" />
          </LabelStyled>
          <LabelValueStyled>
            <TrlDateFormatted date={revokeDate} />
          </LabelValueStyled>
          <LabelStyled>
            {TrlFormattedMessagePlain({
              id: 'TRLT_UI-INITIAL_AMOUNT',
            })}
          </LabelStyled>
          <LabelValueStyled>{initialAmount}</LabelValueStyled>
        </ContainerLeftStyled>
      </BoxValuesStyled>
    </BoxContainerStyled>
  );
};

TrlPrimaryFund.propTypes = {
  dataItem: PropTypes.object,
};
